export default {
  signInUrl: 'https://partners.playstation.net/sign-in',
  clientId: '0oa7bpq6c9rTpddWb1t7',
  environmentName: 'prod',
};
